import { render, staticRenderFns } from "./VMSTextArea.vue?vue&type=template&id=fdf732d6"
import script from "./VMSTextArea.vue?vue&type=script&lang=ts"
export * from "./VMSTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports